import { useMutation } from "@tanstack/react-query";
import API from "@/api";
import { DeviceOfflineError } from "@/errors";
import { Annotation } from "@annotorious/react";

export interface IObservationData {
  note: string;
  annotations: Annotation[];
  image?: File
}

function useCreateObservation(nurseryId: string, rackId: string) {
  const { mutate, isPending, error } = useMutation({
    mutationFn: async (observation: IObservationData) => {
      const { image, ...rest } = observation;

      if (image) {
        API.uploadRackImage(image).catch((error) => {
          if (!(error instanceof DeviceOfflineError)) {
            // Only throw the error of the device is online.
            // Otherwise we want to queue the create-observation request too
            throw error;
          }
        });
      }
      // image?.name || "" is not ideal, but I didn't find a better solution
      const payload = {...rest, image: image?.name || ""};
      return API.createRackObservation(nurseryId, rackId, payload);
    },
  });

  return {
    createObservation: mutate,
    createIsPending: isPending,
    createError: error
  };
}

export default useCreateObservation;
